(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  const collectionToolbar = document.querySelector('[data-collection-toolbar]');

  if (collectionToolbar) {
    let priceSubmitTimer;
    const filterGroups = collectionToolbar.querySelectorAll('.collection__filter-group');

    const submitToolbar = () => {
      if (typeof collectionToolbar.requestSubmit === 'function') {
        collectionToolbar.requestSubmit();
      } else {
        collectionToolbar.submit();
      }
    };

    collectionToolbar.querySelectorAll('[data-auto-submit]').forEach((field) => {
      field.addEventListener('change', submitToolbar);
    });

    collectionToolbar.querySelectorAll('[data-auto-submit-price]').forEach((field) => {
      field.addEventListener('input', () => {
        window.clearTimeout(priceSubmitTimer);
        priceSubmitTimer = window.setTimeout(submitToolbar, 500);
      });

      field.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        window.clearTimeout(priceSubmitTimer);
        submitToolbar();
      });
    });

    filterGroups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;

        filterGroups.forEach((otherGroup) => {
          if (otherGroup !== group) {
            otherGroup.removeAttribute('open');
          }
        });
      });

      group.addEventListener('focusout', (event) => {
        if (group.contains(event.relatedTarget)) return;
        window.setTimeout(() => {
          if (!group.matches(':focus-within')) {
            group.removeAttribute('open');
          }
        }, 0);
      });
    });

    document.addEventListener('click', (event) => {
      if (collectionToolbar.contains(event.target)) return;

      filterGroups.forEach((group) => {
        group.removeAttribute('open');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-featured-collection]');

    sections.forEach((section) => {
      if (section.dataset.source !== 'recommendations') return;

      const grid = section.querySelector('[data-recommendations-grid]');
      const emptyState = section.querySelector('[data-recommendations-empty]');
      const sectionId = section.dataset.sectionId;
      const productId = section.dataset.productId;
      const limit = section.dataset.limit || '4';
      const intent = section.dataset.intent || 'related';

      if (!grid || grid.children.length > 0 || !productId || !sectionId) {
        if (emptyState && grid && grid.children.length > 0) {
          emptyState.classList.add('featured-collection__empty--hidden');
        }
        return;
      }

      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = doc.querySelector('[data-recommendations-grid]');
          if (!incomingGrid || incomingGrid.children.length === 0) return;

          grid.innerHTML = incomingGrid.innerHTML;
          if (emptyState) emptyState.classList.add('featured-collection__empty--hidden');
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.header');

  if (header) {
    const mobileToggle = header.querySelector('.header__mobile-toggle');
    const mobileMenu = header.querySelector('#mobile-menu');
    const desktopDropdowns = header.querySelectorAll('.header__nav-item--has-children');
    const mobileDropdowns = header.querySelectorAll('.mobile-menu__item--has-children');

    const closeMobileMenu = () => {
      if (!mobileToggle || !mobileMenu) return;
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
      mobileDropdowns.forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });
    };

    if (mobileToggle && mobileMenu) {
      mobileToggle.addEventListener('click', () => {
        const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        mobileToggle.setAttribute('aria-expanded', String(!isOpen));
        mobileMenu.classList.toggle('is-open', !isOpen);
      });

      mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMobileMenu);
      });
    }

    mobileDropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;

        mobileDropdowns.forEach((otherDropdown) => {
          if (otherDropdown !== dropdown) {
            otherDropdown.removeAttribute('open');
          }
        });
      });
    });

    desktopDropdowns.forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 1024) return;
        dropdown.setAttribute('open', '');
      });

      dropdown.addEventListener('mouseleave', () => {
        if (window.innerWidth <= 1024) return;
        dropdown.removeAttribute('open');
      });

      dropdown.addEventListener('focusout', (event) => {
        if (dropdown.contains(event.relatedTarget)) return;
        dropdown.removeAttribute('open');
      });
    });

    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;

      desktopDropdowns.forEach((dropdown) => {
        dropdown.removeAttribute('open');
      });

      closeMobileMenu();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heard-about-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popups = document.querySelectorAll('[data-heard-popup]');
    if (!popups.length) return;

    popups.forEach((popup) => {
      const storageKey = popup.dataset.storageKey;
      const frequencyDays = Number(popup.dataset.frequency || 30);
      const delay = Number(popup.dataset.delay || 4000);
      const form = popup.querySelector('form');
      const success = popup.querySelector('[data-heard-success]');
      const bodyField = popup.querySelector('[data-heard-body]');
      const sourceField = popup.querySelector('[data-heard-source]');
      const detailsField = popup.querySelector('[data-heard-details]');
      const closeButtons = popup.querySelectorAll('[data-heard-close]');

      const now = Date.now();
      const expiry = now + frequencyDays * 24 * 60 * 60 * 1000;

      const saveDismissal = () => {
        try {
          window.localStorage.setItem(storageKey, String(expiry));
        } catch (error) {
          // Storage can be unavailable in strict privacy modes.
        }
      };

      const shouldShow = () => {
        if (success) return true;

        try {
          const storedUntil = Number(window.localStorage.getItem(storageKey) || 0);
          return storedUntil < now;
        } catch (error) {
          return true;
        }
      };

      const open = () => {
        popup.classList.add('is-visible');
        popup.querySelector('select, input, button')?.focus();
      };

      const close = () => {
        popup.classList.remove('is-visible');
        saveDismissal();
      };

      closeButtons.forEach((button) => {
        button.addEventListener('click', close);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
          close();
        }
      });

      form?.addEventListener('submit', () => {
        if (bodyField && sourceField) {
          const source = sourceField.value;
          const details = detailsField?.value || '';
          bodyField.value = `How did you hear about us?\n\nSource: ${source}\nDetails: ${details || 'None provided'}`;
        }

        saveDismissal();
      });

      if (shouldShow()) {
        window.setTimeout(open, success ? 0 : delay);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  function initializeHeroCarousel(section) {
    if (!section) return
    if (section.dataset.carouselInitialized === 'true') return

    const slides = Array.from(section.querySelectorAll('[data-slide]'))
    if (slides.length <= 1) {
      section.dataset.carouselInitialized = 'true'
      return
    }

    const dots = Array.from(section.querySelectorAll('[data-dot]'))
    const previousButton = section.querySelector('[data-prev]')
    const nextButton = section.querySelector('[data-next]')
    let activeIndex = 0

    function setActiveSlide(index) {
      if (index < 0) {
        activeIndex = slides.length - 1
      } else {
        if (index >= slides.length) {
          activeIndex = 0
        } else {
          activeIndex = index
        }
      }

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex)
      })

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex)
      })
    }

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        setActiveSlide(activeIndex - 1)
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        setActiveSlide(activeIndex + 1)
      })
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const dotIndex = Number.parseInt(dot.dataset.index || '0', 10)
        setActiveSlide(dotIndex)
      })
    })

    document.addEventListener('shopify:block:select', (event) => {
      const selectedBlockId = event.target && event.target.dataset ? event.target.dataset.blockId : ''
      if (!selectedBlockId) return

      const selectedIndex = slides.findIndex((slide) => slide.dataset.blockId === selectedBlockId)
      if (selectedIndex === -1) return

      setActiveSlide(selectedIndex)
    })

    section.dataset.carouselInitialized = 'true'
  }

  function setupHeroCarousels() {
    document.querySelectorAll('[data-hero-carousel]').forEach((carouselSection) => {
      initializeHeroCarousel(carouselSection)
    })
  }

  setupHeroCarousels()
  document.addEventListener('shopify:section:load', setupHeroCarousels)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  class CustomerAddressForms {
    constructor() {
      this.countrySelects = document.querySelectorAll('[data-address-country-select]');
      this.countrySelects.forEach((countrySelect) => {
        this.setDefaultValue(countrySelect);
        this.updateProvinceOptions(countrySelect);
        countrySelect.addEventListener('change', (event) => {
          this.updateProvinceOptions(event.currentTarget);
        });
      });
    }

    setDefaultValue(select) {
      const defaultValue = select.dataset.default;
      if (defaultValue) {
        select.value = defaultValue;
      }
    }

    updateProvinceOptions(countrySelect) {
      const provinceSelect = countrySelect
        .closest('form')
        .querySelector('[data-address-province-select]');

      if (!provinceSelect) return;

      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      const rawProvinces = selectedOption.getAttribute('data-provinces');
      const provinces = rawProvinces ? JSON.parse(rawProvinces) : [];
      const defaultProvince = provinceSelect.dataset.default;

      provinceSelect.innerHTML = '';

      if (!provinces.length) {
        provinceSelect.disabled = true;
        return;
      }

      provinceSelect.disabled = false;

      provinces.forEach((province) => {
        const option = document.createElement('option');
        option.value = province[0];
        option.textContent = province[0];

        if (defaultProvince && defaultProvince === province[0]) {
          option.selected = true;
        }

        provinceSelect.appendChild(option);
      });
    }
  }

  window.addEventListener('DOMContentLoaded', () => new CustomerAddressForms());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-product-section]');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.productInitialized === 'true') return;
      section.dataset.productInitialized = 'true';

      const imageWrappers = section.querySelectorAll('.product__image-wrapper');
      const thumbnails = section.querySelectorAll('.product__thumbnail');

      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.index);

          imageWrappers.forEach((item, itemIndex) => {
            item.classList.toggle('product__image-wrapper--active', itemIndex === index);
          });

          thumbnails.forEach((button, buttonIndex) => {
            const active = buttonIndex === index;
            button.classList.toggle('product__thumbnail--active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      const quantityButtons = section.querySelectorAll('.product__quantity-btn');
      quantityButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const input = section.querySelector('.product__quantity-field');
          if (!input) return;

          const currentValue = Number(input.value) || 1;
          const newValue = button.dataset.action === 'increase'
            ? currentValue + 1
            : Math.max(1, currentValue - 1);

          input.value = String(newValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      const variantDataNode = section.querySelector('[data-variants-json]');
      const optionInputs = section.querySelectorAll('[data-option-index]');

      if (!variantDataNode || !optionInputs.length) return;

      let variants = [];
      try {
        variants = JSON.parse(variantDataNode.textContent);
      } catch (error) {
        return;
      }

      const variantIdInput = section.querySelector('[data-variant-id]');
      const priceCurrent = section.querySelector('[data-price-current]');
      const priceCompare = section.querySelector('[data-price-compare]');
      const saleBadge = section.querySelector('[data-sale-badge]');
      const addButton = section.querySelector('[data-add-to-cart]');

      const formatMoneyFromCents = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }

        return (Number(cents) / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: section.dataset.currency || 'USD'
        });
      };

      const updateVariant = () => {
        const selectedValues = [];
        optionInputs.forEach((input) => selectedValues.push(input.value));

        const matchedVariant = variants.find((variant) => {
          if (!variant.options || variant.options.length != selectedValues.length) return false;

          return variant.options.every((optionValue, index) => optionValue === selectedValues[index]);
        });

        if (!matchedVariant) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.labelSold;
          return;
        }

        variantIdInput.value = matchedVariant.id;

        const hasComparePrice = Number(matchedVariant.compare_at_price) > Number(matchedVariant.price);
        priceCurrent.textContent = matchedVariant.price_formatted || formatMoneyFromCents(matchedVariant.price);
        priceCurrent.classList.toggle('product__price-current--sale', hasComparePrice);

        if (hasComparePrice) {
          priceCompare.textContent = matchedVariant.compare_at_price_formatted || formatMoneyFromCents(matchedVariant.compare_at_price);
          priceCompare.classList.remove('hidden');
          saleBadge.classList.remove('hidden');
        } else {
          priceCompare.classList.add('hidden');
          saleBadge.classList.add('hidden');
        }

        if (matchedVariant.available) {
          addButton.disabled = false;
          addButton.textContent = addButton.dataset.labelAdd;
        } else {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.labelSold;
        }
      };

      optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
      updateVariant();

      // Zoom
      const zoomContainer = section.querySelector('[data-zoom]');
      if (zoomContainer) {
        let isZoomed = false;

        const getActiveImage = () => zoomContainer.querySelector('.product__image-wrapper--active .product__image');

        zoomContainer.addEventListener('click', () => {
          isZoomed = !isZoomed;
          zoomContainer.classList.toggle('product__images--zoomed', isZoomed);
          if (!isZoomed) {
            const img = getActiveImage();
            if (img) img.style.transformOrigin = '50% 50%';
          }
        });

        zoomContainer.addEventListener('mousemove', (e) => {
          if (!isZoomed) return;
          const img = getActiveImage();
          if (!img) return;
          const rect = zoomContainer.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        });

        zoomContainer.addEventListener('mouseleave', () => {
          if (!isZoomed) return;
          const img = getActiveImage();
          if (img) img.style.transformOrigin = '50% 50%';
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
